import { render, staticRenderFns } from "./userListTable.vue?vue&type=template&id=2bb70d2f&scoped=true"
import script from "./userListTable.vue?vue&type=script&lang=js"
export * from "./userListTable.vue?vue&type=script&lang=js"
import style0 from "./userListTable.vue?vue&type=style&index=0&id=2bb70d2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb70d2f",
  null
  
)

export default component.exports